export default (opts = {}) => {
  const component = {
    model: {
      defaults: {
        type:'section', 
        tagname:'section',
        name: "Seção Blog",
        attributes: { class: 'section' },
        components: [
          {
            type: 'containerBlog'
          }          
        ],
        styles: `
       .section{
        padding:75px 5%; 
       }
        *{
          font-family: Roboto, Arial, sans-serif;
       }
      `,
       },
    },
    view: {

    },
  };

  return component;
};

